<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">KELİME SAYISI</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="2"
            :max="4"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">KELİMELER</label>
          <el-switch
            style="margin-top: 8px"
            v-model="direction"
            active-text="KARIŞIK"
            :active-value="'karisik'"
            :inactive-value="'yanyana'"
            inactive-text="YANYANA"
          >
          </el-switch>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.mode")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="mode"
            :inactive-text="$t('module.group')"
            :active-value="2"
            :inactive-value="1"
            :active-text="$t('module.same')"
          >
          </el-switch>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      id="goz_esnetme"
      @click="
        pause = true;
        $root.$emit('pause', true);
      "
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        v-if="currentCounter != 0"
        style="
          font-size: 20px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-block;
          text-align: center;
          margin: 3px;
          background-color: white;
          padding: 3px 10px;
        "
        v-for="item in options"
        :style="{
          marginRight: 5 + 'px',
          top: item.top + 'px',
          left: item.left + 'px',
          position: direction == 'karisik' ? 'absolute' : '',
        }"
      >
        {{ item.word }}
      </div>
    </div>
    <div
      :style="{ width: wrapper.width + 'px' }"
      style="margin: 0 auto; border-radius: 0px; margin-top: 15px"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
        "
        v-if="pause == false"
      >
        <div style="display: flex; flex-direction: row">
          <el-button
            :disabled="currentCounter > 0"
            :type="trueClass"
            @click="pick('true')"
            v-html="mode == 1 ? $t('module.isgroup') : $t('module.issame')"
          ></el-button>
          <el-button
            :disabled="currentCounter > 0"
            :type="falseClass"
            @click="pick('false')"
            v-html="
              mode == 1 ? $t('module.isnotgroup') : $t('module.isnotsame')
            "
          ></el-button>
        </div>
        <div style="display: flex; flex-direction: row">
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div
              style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              "
            >
              <i class="fas fa-times"></i>
            </div>
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              "
              >{{ totalFalse }}</span
            >
          </span>
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              "
              >{{ totalTrue }}</span
            >
          </span>
          <svg
            height="40px"
            viewBox="0 0 512 512"
            width="40px"
            xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2"
          >
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)"
            />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: ["config"],
  name: "GozEsnekligi",
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [
        2000, 1900, 1800, 1700, 1600, 1500, 1400, 1300, 1200, 1100, 1000, 800,
        600, 500, 400, 300,
      ],
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
      currentCounter: 155,
      startCounter: 5,
      level: 2,
      groups: [
        "bıçak,tencere,tepsi,çaydanlık,tava,çatal,kaşık,bardak,fincan,spatula,blender,rende,süzgeç,buzdolabı,ocak,fırın,davlumbaz".split(
          ","
        ),
        "domates,patates,patlıcan,pırasa,soğan,havuç,biber,sarımsak,zencefil,ıspanak,pancar,lahana,fasulye,mısır,çay,bezelye,bamya,enginar,kabak,nektari".split(
          ","
        ),
        "üzüm,muz,kiraz,elma,vişne,şeftali,portakal,mandarin,böğürtlen,kayısı,armut,mango,incir,hurma,ceviz,karpuz,kavun,erik,fındık,kızılcık,dut".split(
          ","
        ),
        "gül,lale,sümbül,papatya,karahindiba,menekşe,maydanoz,çimen,nane,biberiye,zerdeçal,yosun,çavdar,yulaf,buğday,kaktüs,mısır,fesleğen".split(
          ","
        ),
      ],
      sames:
        "abide;abize,açı;aşı,acil;aciz,ani;adi,ahlak;ahmak,akbaş;aktaş,akıllı;akılcı,akıntı;akıncı,aksan;aksam,anket;antet,armatör;armatür,ayaz;ayas,asık;aşık,aylık;ayrık,baba;baca,balkan;balkon,batıl;bayıl,başla;bağla,baz;bez,bedel;beden,beste;deste,berber;barbar,bıyık;bıdık,bidon;bijon,biber;birer,bomba;bombe,boynuz;boysuz,boyun;boyut,bulanık;bulaşık,böyle;bile,çakıl;çekil,cilacı;cilalı,çemen;çimen,çekingen;çevirmen,çıta;çita,çınla;çıtla,dağcılık;dağarcık,dalgıç;del,dalgıç;dalgın,damar;danar,damla;dolma,darı;dara,dayanak;dayamak,defile;define,dere;deri,diren;dilen,değer;diğer,değişken;değirmen,diyet;diyez,dizel;düzel,doğal;doğan,dolaşım;dolaşık,dönem;döner,dövme;dökme,duman;dümen,duru;duyu,dua;duva,düşey;düzey,edebi;ebedi,ekim;ekin,eksen;eksin,elit;elif,elem;emel,emanet;emaret,emekçi;emekli,emlak;eflak,erişte;enişte,ergen;ergin,ezel;ecel,etek;etik,fes;fas,gece;gebe,geçici;gerili,geçerli;gerekli,gıcır;gıcık,gıda;gına,hakim;hekim,güney;güvey,hareket;harekat,harika;harita,harran;harman,hemşire;hemşeri,heyelan;heyecan,hızar;hıyar,Hilal;Halil,hizmet;hazmet,hobi;fobi,ikindi;ikinci,insan;insaf,işte;iste,jakuzi;jaluzi,kabak;kaban,kabin;kabir,kader;kadir,kafes;kodes,kamara;kamera,keder;kader,kafiye;kafile,kalem;kelam,kasım;kısım,kazan;kızan,kaz;kez,kedi;keçi,kemikli;kemiksi,kese;kete,kıdem;kadem,kırım;sırım,kısıntı;kasıntı,kıvrak;kıvrık,kibar;kabir,kilim;kilis,kişi;kivi,konser;kanser,korna;kurna,levrek;leyrek,lojman;lokman,maden;madem,mağaza;mağara,makas;makam,mani;mana,metalik;metelik,mey;ney,minik;mimik,nakliyat;bakliyat,nazar;nazır,nefes;nefis,nezaket;nezaret,nişan;nisan,niyetçi;niyetli,oduncu;odunsu,ortam;ortak,oyun;odun,örnek;ördek,öyle;önce,özgür;özgün,palavra;paçavra,park;pars,plan;plak,rekabet;rekaret,resim;resmi,ray;rey,sabah;saban,sabuncu;sabunlu,sahne;sahte,sakal;sakin,saman;seman,sefalet;sefaret,serap;sevap,selam;salam,seksen;seksek,sepici;sepili,sıkıcı;sıkıca,sıkma;sıtma,sınır;sıfır,sıvı;sıva,sincap;sincan,sine;sini,siper;süper,soyut;somut,tadım;takım,takıl;tahıl,tabela;talebe,talep;talip,tasarruf;tasavvuf,tekrar;tekrir,tencere;pencere,tıkaç;tokaç,tırnak;tırmık,tırtıl;tırtır,timsah;timsal,titiz;tiriz,uçak;uçuk,uçarı;uyarı,uçurtma;uçuşma,ufuk;ufak,vatan;yatan,vaziyet;vasiyet,virgül;birgül,yakınsak;yakınmak,yamuk;yamak,yanık;yankı,yankı;yancı,yapım;yapıt,yaprak;yıprak,yarma;yorma,yedekli;yedekçi,yelek;yalak,yemişli;yemişçi,yeşermek;yaşarmak,yetmiş;yatmış,yıldız;yaldız,yönelim;yönetim,yünlü;yönlü,zaman;zemin,zeka;zeki,zeybek;zeyrek,ziyafet;ziyaret,yanlış;yalnış,yanıl;yayıl,yar;yer"
          .split(",")
          .map((k) => {
            return [k.split(";")[0], k.split(";")[1]];
          }),
      options: [],
      currentLetter: {
        group: "",
        metin: "",
      },
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      positions: [],
      totalTrue: 0,
      totalFalse: 0,
      counts: [],
      flash: false,
      answer: null,
      pickedAnswer: "",
      settings: false,
      mode: 1,
      direction: "yanyana",
      autoLevel: 0,
      options: [],
      isGroupOrSame: false,
      levelLock: false,
      lock: false,
      reactions: [],
      lastPickTime: new Date().getTime(),
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getColor(letter) {
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == false
      ) {
        return "#ddd";
      }
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
      if (
        this.flash == true &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
    },
    pick(answer) {
      if (this.lock) return;
      this.lock = true;
      this.pickedAnswer = answer.toString();
      if (answer == this.isGroupOrSame.toString()) {
        this.reactions.push(new Date().getTime() - this.lastPickTime);
        this.totalTrue += 1;
      } else {
        this.totalFalse += 1;
      }
      setTimeout(() => {
        this.start();
        this.pickedAnswer = "";
        this.lock = false;
      }, 1500);
    },
    start() {
      this.flash = false;
      this.positions = [];
      this.options = [];
      this.currentCounter = 3;

      if (this.mode == 1) {
        this.groups = _.shuffle(this.groups);

        var isGroupOrSame = _.random(0, 9999) % 2 == 0;
        this.isGroupOrSame = isGroupOrSame;

        if (isGroupOrSame) {
          var pick = _.random(0, this.groups[0].length - 1);

          for (let index = 0; index < this.level; index++) {
            this.options.push({
              word: this.groups[0][pick],
              top: _.random(20, this.wrapper.height - 100),
              left: _.random(20, this.wrapper.width - 100),
            });

            while (true) {
              if (this.options.some((k) => k.word == this.groups[0][pick])) {
                pick = _.random(0, this.groups[0].length - 1);
              } else {
                break;
              }
            }
          }
        } else {
          var x = this.level > 3 ? 2 : 1;

          var pick = _.random(0, this.groups[0].length - 1);

          for (let index = 0; index < this.level - x; index++) {
            this.options.push({
              word: this.groups[0][pick],
              top: _.random(20, this.wrapper.height - 100),
              left: _.random(20, this.wrapper.width - 100),
            });

            while (true) {
              if (this.options.some((k) => k.word == this.groups[0][pick])) {
                pick = _.random(0, this.groups[0].length - 1);
              } else {
                break;
              }
            }
          }

          for (let index = 0; index < x; index++) {
            this.options.push({
              word: this.groups[1][pick],
              top: _.random(20, this.wrapper.height - 100),
              left: _.random(20, this.wrapper.width - 100),
            });

            pick = _.random(0, this.groups[0].length - 1);
          }
        }
      }

      if (this.mode == 2) {
        this.sames = _.shuffle(this.sames);

        var isGroupOrSame = _.random(0, 9999) % 2 == 0;

        this.isGroupOrSame = isGroupOrSame;

        if (isGroupOrSame) {
          var pick = _.random(0, 1);

          for (let index = 0; index < this.level; index++) {
            this.options.push({
              word: this.sames[0][0],
              top: _.random(20, this.wrapper.height - 100),
              left: _.random(20, this.wrapper.width - 100),
            });
          }
        } else {
          var x = this.level > 3 ? 2 : 1;

          var pick = _.random(0, 1);

          for (let index = 0; index < this.level - x; index++) {
            this.options.push({
              word: this.sames[0][pick],
              top: _.random(20, this.wrapper.height - 100),
              left: _.random(20, this.wrapper.width - 100),
            });
          }

          for (let index = 0; index < x; index++) {
            this.options.push({
              word: this.sames[0][pick == 1 ? 0 : 1],
              top: _.random(20, this.wrapper.height - 100),
              left: _.random(20, this.wrapper.width - 100),
            });
          }
        }
      }
      this.interval = setTimeout(() => {
        this.lastPickTime = new Date().getTime();
        this.currentCounter = 0;
      }, this.speeds[this.speed - 1]);
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
    trueClass() {
      if (this.pickedAnswer == "") {
        return "";
      }
      if (
        this.pickedAnswer == this.isGroupOrSame.toString() &&
        this.pickedAnswer == "true"
      ) {
        return "success";
      }
      if (
        this.isGroupOrSame.toString() == "true" &&
        this.pickedAnswer == "false"
      ) {
        return "success";
      }
      if (
        this.isGroupOrSame.toString() == "false" &&
        this.pickedAnswer == "true"
      ) {
        return "danger";
      }
      return "";
    },
    falseClass() {
      if (this.pickedAnswer == "") {
        return "";
      }
      if (
        this.pickedAnswer == this.isGroupOrSame.toString() &&
        this.pickedAnswer == "false"
      ) {
        return "success";
      }
      if (
        this.isGroupOrSame.toString() == "false" &&
        this.pickedAnswer == "true"
      ) {
        return "success";
      }
      if (
        this.isGroupOrSame.toString() == "true" &&
        this.pickedAnswer == "false"
      ) {
        return "danger";
      }
      return "";
    },
  },
  created() {
    if (this.config != null && this.config != undefined) {
      if (this.config.mode != null && this.config.mode != "")
        this.mode = this.config.mode;
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      if (this.config.speed != null && this.config.speed != "")
        this.speed = this.config.speed;
      if (this.config.direction != null && this.config.direction != "")
        this.direction = this.config.direction;
      if (this.config.autoLevel != null && this.config.autoLevel != "")
        this.autoLevel = this.config.auto_level;
    }
  },
  watch: {
    currentSpeed: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    level: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    mode: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    totalTrue() {
      if (this.autoLevel == 0) {
        return;
      }

      if (this.totalTrue % 2 == 0) {
        this.levelLock = true;
        this.level = Math.min(
          this.level + 1,
          this.config && this.config.max_level ? this.config.max_level : 4
        );
        this.speed = Math.min(
          this.speed + 1,
          this.config && this.config.max_speed ? this.config.max_speed : 16
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/CokluFokus.vue